import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Card, CardContent, Typography, Collapse, Avatar, Button,MenuItem,FormControlLabel,Checkbox,Menu, IconButton, Tooltip, Modal, Box, Popover,Backdrop, Grid } from "@mui/material";
import GridViewIcon from "@mui/icons-material/GridView";
import FilterListIcon from '@mui/icons-material/FilterList';
import ViewAgendaIcon from "@mui/icons-material/ViewAgenda";
import OpenInFullIcon from "@mui/icons-material/OpenInFull"; 
import CloseFullscreenIcon from "@mui/icons-material/CloseFullscreen"; 
import dayjs from "dayjs";
import { list, getLiveOrders, getPendingOrders } from "../api/actions/query";
import { messageShow } from "../../common/api/actions";
import { orderacceptedToggle, paidToggle, dispatchToggle, deliverToggle, cancel, remove } from "../api/actions/mutation";
import SectionPaper from "../../common/SectionPaper";
import BrandedLoading from "../../common/BrandedLoading";
import EmptyMessage from "../../common/EmptyMessage";
import PrintIcon from "@mui/icons-material/Print";
import CancelIcon from "@mui/icons-material/Cancel"; 
import DeleteIcon from "@mui/icons-material/Delete";
import QrCodeIcon from "@mui/icons-material/QrCode";
import { Link } from "react-router-dom";
import routes from "../api/routes";
import StorefrontIcon from "@mui/icons-material/Storefront"; 
import HomeIcon from "@mui/icons-material/Home"; 
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import AccessTimeIcon from '@mui/icons-material/AccessTime'; 
import ArticleIcon from '@mui/icons-material/Article'; 
import CheckIcon from '@mui/icons-material/Check'; 
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import { createQuote, createDelivery,vendorDetails,getUberDeliveryDetails,getDeliveryDetails,} from "../../uberDelivery/api/actions/query";
import { DirectionsCar, LightbulbOutlined as LightbulbOutlinedIcon, ChevronRight as ChevronRightIcon, Smartphone as SmartphoneIcon, Close as CloseIcon } from '@mui/icons-material';
import { checkPermission } from "../../common/Sidebar/checkPermission";
import Pagination from "@mui/material/Pagination";
class LiveOrder extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      count: 0,
      page: props.match.params.page || 1,
      search: "",
      currencySymbol: "",
      activeOrder: null,
      isVerticalLive: false,
      areAllOrdersExpandedLive: true,
      filterTypeLive: '',
      isVerticalPending: false,
      areAllOrdersExpandedPending: false,
      filterTypePending: '',
      barcodeModalOpen: false,

      anchorEl: null, 
      selectedCoupon: null,
      filterAnchorElLive: null,
      filterAnchorElPending: null,
      tempFiltersLive: { inProgress: false, accepted: false, paid: false, dispatched: false, delivered: false, cancelled: false },
      filtersLive: { inProgress: false, accepted: false, paid: false, dispatched: false, delivered: false, cancelled: false },
      tempFiltersPending: { inProgress: false, accepted: false, paid: false, dispatched: false, delivered: false, cancelled: false },
      filtersPending: { inProgress: false, accepted: false, paid: false, dispatched: false, delivered: false, cancelled: false },
      liveOrdersToday: [], 
      pendingOrders: [],
      loadingStatus: {}, 
      order: null,
      vendor: null,
      quote: null,
      delivery: null,
      uberDelivery: null, 
      stage: "Quote",
      error: null,
      isLoading: true,
      hasLoadedOnce: false,
      showPendingOrders: false,
      pendingLoading: false,
      pendingLoadedOnce: false,
      settingsData:null,
      showDeliveryChoiceModal: false,
      onDeliveryChoice: null,
      selectedOrder: null, 
      permissions: {
        canView: false,
        canCreate: false,
        canEdit: false,
        canDelete: false,
      },
      itemsPerPage: 20,
      selectedPendingOrders: [],
      isSelectionMode: false,
      isAllSelectedAcrossPages: false,
      preferenceModalOpen: false,
      selectedPreferences: ""
    };
  }

  componentDidMount() {
    this.fetchLiveOrders();
    this.verifyPermissions();
  }
  componentDidUpdate(prevProps) {
    const { location, match } = this.props;

    if (prevProps.location.pathname !== location.pathname || prevProps.match.params.page !== match.params.page) {
      const newPage = parseInt(match.params.page) || 1;
      this.setState({ page: newPage }, () => {
        this.fetchPendingOrders(newPage);
      });
    }
  }

  verifyPermissions = async () => {
    const modulePermission = await checkPermission("store", "orders.liveOrders");
    this.setState({permissions:{canEdit:modulePermission.canEdit,canDelete: modulePermission.canDelete,canCreate: modulePermission.canCreate,canView: modulePermission.canView}});
  };
  
  fetchLiveOrders = async () => {
    const { messageShow, getLiveOrders } = this.props;
    try {
      this.setState({ isLoading: true });
      const liveResponse = await getLiveOrders("all");
      const liveOrdersToday = liveResponse?.data?.data?.liveOrders || [];
      const currencySymbol = liveResponse?.data?.data?.settingsData?.currencyData?.symbol;
      const settingsData = liveResponse?.data?.data?.settingsData || null;

      this.setState({
        liveOrdersToday,
        currencySymbol,
        settingsData,
        isLoading: false,
        hasLoadedOnce: true,
      });
      if (settingsData?.isUberDeliveryEnabled) {
        await this.fetchVendorDetails();
      }
    } catch (error) {
      console.error("Error fetching live orders:", error);
      messageShow(error.message || "Something went wrong");
      this.setState({ isLoading: false });
    }
  };
  
  fetchPendingOrders = async (page = this.state.page) => {
    const { messageShow, getPendingOrders } = this.props;
    const { itemsPerPage } = this.state;

    try {
      this.setState({ pendingLoading: true });
      const pendingResponse = await getPendingOrders(page, itemsPerPage);
      const pendingOrders = pendingResponse?.data?.data?.pendingOrders || [];
      const totalCount = pendingResponse?.data?.data?.total || 0;

      this.setState({
        pendingOrders,
        count: totalCount,
        pendingLoading: false,
        pendingLoadedOnce: true,
      });
    } catch (error) {
      console.error("Error fetching pending orders:", error);
      messageShow(error.message || "Something went wrong");
      this.setState({ pendingLoading: false });
    }
  };

  handlePageChange = (event, pageNumber) => {
    const { history } = this.props;
    history.push(`/liveorders/${pageNumber}`);
    this.setState({ page: pageNumber });
  };
    
  fetchVendorDetails = async () => {
    try {
      const { data } = await vendorDetails();
      this.setState({ vendor: data.data, isLoading: false });
    } catch (error) {
      this.setState({ error: error.message, isLoading: false });
    }
  };
  fetchUberDeliveryDetails = async (order) => {
    if (!order || !order._id) {
      this.setState({ error: "Invalid order data", isLoading: false });
      return;
    }
    
    try {
      this.setState({ isLoading: true });
  
      const { data } = await getUberDeliveryDetails(order._id);
  
      if (data?.data?.uberDelivery) {
        const uberDelivery = data.data.uberDelivery;
        
        const isDelivered = uberDelivery.deliveryStatus === "delivered";
      
        const updatedLiveOrders = this.state.liveOrdersToday.map(o => {
          if (o._id === order._id) {
            return { 
              ...o, 
              uberDeliveryId: uberDelivery,
              isDelivered: isDelivered ? true : o.isDelivered
            };
          }
          return o;
        });
        const updatedPendingOrders = this.state.pendingOrders.map(o => {
          if (o._id === order._id && !o.isCancelled && !o.isDelivered && !o.isDeleted) {
            return { 
              ...o, 
              uberDeliveryId: uberDelivery,
              isDelivered: isDelivered ? true : o.isDelivered
            };
          }
          return o;
        });
        this.setState({ 
          liveOrdersToday: updatedLiveOrders,
          pendingOrders: updatedPendingOrders,
          uberDelivery: data.data.uberDelivery,
          isLoading: false,
        });
  
      } else {
        this.setState({
          error: "Uber delivery details not found",
          isLoading: false,
        });
      }
    } catch (error) {
      this.setState({ error: error.message, isLoading: false });
    }
  };          

  handleOrderClick = (order) => {  
    if (order?.isUberDelivery && order.uberDelivery?.deliveryStatus !== "delivered") {
      this.getUberDeliveryStatus(order);
    } 
  };

  createQuote = async(order)=>{
    const { vendor } = this.state;
    if (!order || !vendor) {
      this.setState({
        error: "details not available",
        isLoading: false,
      });
      return;
    }

     const quoteData = {
      orderId: order.id,
      pickupAddress: {
        street_address: vendor.address.street1,
        city: vendor.address.city,
        state: vendor.address.state,
        zip_code: vendor.address.pincode,
        country: vendor.address.country,
      },
      dropoffAddress: {
        street_address: [order.addressDetails.street1, order.addressDetails.street2].join(" ").trim(),
        city:  order.addressDetails.city,
        state: vendor.address.state,
        zip_code: order.addressDetails.pincode,
        country: vendor.address.country,
      },
      pickupPhoneNumber: vendor.phoneNumber,
      dropoffPhoneNumber: order.userDetails.mobile,
      manifestTotalValue: Math.round(order.amountTotal * 100),
      pickupCoordinates: {
        latitude: vendor.address?.lat,
        longitude: vendor.address?.lng,
      },
      dropoffCoordinates: {
        latitude: order.addressDetails.lat,
        longitude: order.addressDetails.lng,
      },
      externalStoreId: "123"
    };  
    try {
      const data = await createQuote(quoteData);
      return data; 
    } catch (error) {
      console.error("Error creating Quote: ",error)
      this.setState({ error: error.message, isLoading: false });
      return null;
    }
  }

  createDelivery = async (order) => {
    const { vendor } = this.state;
  
    if (!order || !vendor) {
      this.setState({
        error: "details not available",
        isLoading: false,
      });
      return;
    }
   
    const items = Object.values(order.cartrequest).map((item) => ({
      name: item.name,
      quantity: item.count,
      weight: item.weight || 1,
      price:  Math.round((item.priceDiscount > 0 ? item.priceDiscounted : item.price) * 100),
    }));
  
    const deliveryData = {
      orderId: order._id,
      pickupDetails: {
        name: vendor.name,
        address: {
          street_address: [vendor.address.street1, vendor.address.street2]
            .join(" ")
            .trim(),
          city: vendor.address.city,
          state: vendor.address.state,
          zip_code: vendor.address.pincode,
          country: vendor.address.country,
        },
        phoneNumber: vendor.phoneNumber,
      },
      dropoffDetails: {
        name: order.userDetails.name,
        address: {
          street_address: [order.addressDetails.street1, order.addressDetails.street2]
            .join(" ")
            .trim(),
          city: order.addressDetails.city,
          state: vendor.address.state,
          zip_code: order.addressDetails.pincode,
          country: vendor.address.country,
        },
        phoneNumber: order.userDetails.mobile,
      },
      pickupCoordinates: {
        latitude: vendor.address?.lat,
        longitude: vendor.address?.lng,
      },
      dropoffCoordinates: {
        latitude: order.addressDetails.lat,
        longitude: order.addressDetails.lng,
      },
      manifestItems: items,
      manifestTotalValue: Math.round(order.amountTotal * 100),
      externalStoreId: "123",
    };
  
    try {
      const response = await createDelivery(deliveryData);
     
      if (response.data.success){
        const updatedLiveOrders = this.state.liveOrdersToday.map((o) =>
          o._id === order._id
          ? { ...o, uberDeliveryId: response.data.uberDelivery } 
          : o
        );
        const updatedPendingOrders = this.state.pendingOrders.map((o) =>
          o._id === order._id && !o.isCancelled && !o.isDelivered && !o.isDeleted
          ? { ...o, uberDeliveryId: response.data.uberDelivery } 
          : o
        );
        this.setState({ 
          liveOrdersToday: updatedLiveOrders, 
          pendingOrders: updatedPendingOrders,
          delivery: response.data.data,
          isLoading: false 
        });
      }
  
      this.fetchUberDeliveryDetails(order);
      this.fetchLiveOrders();
    } catch (error) {
      this.setState({ error: error.message, isLoading: false });
      console.error("Error creating Delivery: ",error)
    }
  };  

  getUberDeliveryStatus = async (order) => {
    if (!order.uberDelivery || !order.uberDelivery.deliveryId) {
      return; 
    }
    
    try {
      this.setState(prevState => ({
        loadingStatus: { ...prevState.loadingStatus, [order._id]: "Checking status..." }
      }));
  
      const { data } = await getDeliveryDetails(order.uberDelivery.deliveryId);
      const newStatus = data.data.status;
        
      if (newStatus) {
        const isDelivered = newStatus === "delivered";
    
        const updatedLiveOrders = this.state.liveOrdersToday.map(o =>
          o._id === order._id
          ? { ...o, uberDelivery: { ...o.uberDelivery, deliveryStatus: newStatus }, isDelivered }
          : o)

        const updatedPendingOrders = this.state.pendingOrders.map(o =>
          o._id === order._id && !o.isCancelled && !o.isDelivered && !o.isDeleted
          ? { ...o, uberDelivery: { ...o.uberDelivery, deliveryStatus: newStatus }, isDelivered }
          : o)

        this.setState(prev => ({
          liveOrdersToday: updatedLiveOrders,
          pendingOrders: updatedPendingOrders,
          loadingStatus: { ...prev.loadingStatus, [order._id]: null }
        }));
  
        if (isDelivered && !order.isDelivered) {
          await this.props.deliverToggle({ orderId: order._id });
        } else {
          this.setState(prev => ({
            loadingStatus: { ...prev.loadingStatus, [order._id]: null }
          }));
        }
      } 
    }
    catch (error) {
      this.setState(prevState => ({
        loadingStatus: { ...prevState.loadingStatus, [order._id]: null }
      }));
    }
  };
    
  checkUberDeliveryConditions = async (order) => {
    const { settingsData } = this.state;
    if (!settingsData || !settingsData.isUberDeliveryEnabled) {
      return false; 
    }
    const deliveryTypes = settingsData.homeDelivery?.deliveryType || [];
  
    if (!order.cartrequest || !deliveryTypes.includes('UBER')) {
       return false; 
    }
     if (deliveryTypes.includes('UBER') && deliveryTypes.includes('SELF')) {
        const userChoice = await this.showDeliveryChoiceModal(order);
        return userChoice === 'UBER'; 
     }   
   return true; 
  }

  showDeliveryChoiceModal = (order) => {
    return new Promise((resolve) => {
      this.setState({
      showDeliveryChoiceModal: true,
      selectedOrder: order,
      onDeliveryChoice: (choice) => {
        this.setState({ showDeliveryChoiceModal: false, onDeliveryChoice: null,  selectedOrder: null });
        resolve(choice);
      }
      });
    });
  };
  
  handleOrderStatusChange = async (orderId, isOrderAccepted) => {
    const { orderacceptedToggle, messageShow } = this.props;
    this.setState(prevState => ({
      loadingStatus: { ...prevState.loadingStatus, [orderId]: "Accepting..." }
    }));
  
    try {
      const response = await orderacceptedToggle({
        orderId,
        isOrderAccepted: !isOrderAccepted, 
      });
    
      if (response.data.success){
        messageShow(response.data.message);
      }
      const updatedLiveOrders = this.state.liveOrdersToday.map(order =>
        order._id === orderId ? { ...order, isOrderAccepted: !isOrderAccepted } : order
      );

      const updatedPendingOrders = this.state.pendingOrders.map(order =>
        order._id === orderId && !order.isCancelled && !order.isDelivered && !order.isDeleted
        ? { ...order, isOrderAccepted: !isOrderAccepted }
        : order
      );
  
      this.setState({
        liveOrdersToday: updatedLiveOrders,
        pendingOrders: updatedPendingOrders,
        loadingStatus: { ...this.state.loadingStatus, [orderId]: null }
      });
  
    } catch (error) {
      console.error("Error in handleOrderStatusChange: ", error);
      messageShow(error.message || "Error updating order status");
      this.setState(prevState => ({
        loadingStatus: { ...prevState.loadingStatus, [orderId]: null } 
      }));
    }
  };
                          
  handlePaidStatusChange = async (orderId) => {
    const { paidToggle, messageShow } = this.props;
  
    this.setState(prevState => ({
      loadingStatus: { ...prevState.loadingStatus, [orderId]: "Paying..." }
    }));
  
    try {
      const response = await paidToggle({ orderId, paymentStatus: "done" });
      if (response.data.success){
        messageShow(response.data.message);
      }
      const updatedLiveOrders = this.state.liveOrdersToday.map(order =>
        order._id === orderId ? { ...order, paymentDetails: { ...order.paymentDetails, status: "done" } } : order
      );

      const updatedPendingOrders = this.state.pendingOrders.map(order =>
        order._id === orderId && !order.isCancelled && !order.isDelivered && !order.isDeleted 
        ? { ...order, paymentDetails: { ...order.paymentDetails, status: "done" } } 
        : order
      );
  
      this.setState({
        liveOrdersToday: updatedLiveOrders,
        pendingOrders: updatedPendingOrders,
        loadingStatus: { ...this.state.loadingStatus, [orderId]: null } 
      });
  
    } catch (error) {
      messageShow(error.message || "Error updating payment status");
      this.setState(prevState => ({
        loadingStatus: { ...prevState.loadingStatus, [orderId]: null } 
      }));
    }
  };  
  
  handleDispatchStatusChange = async (orderId) => {
    const { dispatchToggle, messageShow } = this.props;

    this.setState(prevState => ({
      loadingStatus: { ...prevState.loadingStatus, [orderId]: "Dispatching..." }
    }));
  
    try {
      const response = await dispatchToggle({ orderId });
      if (response.data.success){
        messageShow(response.data.message);
      }
  
      const updatedLiveOrders = this.state.liveOrdersToday.map(order =>
        order._id === orderId ? { ...order, isDispatched: true } : order
      );

      const updatedPendingOrders = this.state.pendingOrders.map(order =>
        order._id === orderId && !order.isCancelled && !order.isDelivered && !order.isDeleted
        ? { ...order, isDispatched: true } : order
      );
  
      this.setState({
        liveOrdersToday: updatedLiveOrders,
        pendingOrders: updatedPendingOrders,
      });
  
      const order = [...this.state.liveOrdersToday, ...this.state.pendingOrders].find(order => order._id === orderId);

      if (await this.checkUberDeliveryConditions(order)) {
          const quote = await this.createQuote(order);
          if (quote) {
            await this.createDelivery(order); 
          } else {
           console.log("Quote creation failed, skipping delivery creation");
          }
      }

      this.setState(prevState => ({
        loadingStatus: { ...prevState.loadingStatus, [orderId]: null }
      }));
  
    } catch (error) {
      messageShow(error.message || "Error updating dispatch status");
      this.setState(prevState => ({
        loadingStatus: { ...prevState.loadingStatus, [orderId]: null } 
      }));
    }
  };
  
  handleDeliverStatusChange = async (orderId) => {
    const { deliverToggle, messageShow } = this.props;
  
    this.setState(prevState => ({
      loadingStatus: { ...prevState.loadingStatus, [orderId]: "Delivering..." }
    }));
  
    try {
      const orderToUpdate = this.state.liveOrdersToday.find(order => order._id === orderId);
    
      if (orderToUpdate?.isUberDelivery && 
        orderToUpdate.uberDelivery?.deliveryStatus === "delivered") {
        const response = await deliverToggle({ orderId });
        messageShow(response.data.message || "Order marked as delivered");
      } else {
        const response = await deliverToggle({ orderId });
        if (response.data.success){
          messageShow(response.data.message || "Order marked as delivered");
        }
      }
  
      const updatedLiveOrders = this.state.liveOrdersToday.map(order =>
        order._id === orderId ? { ...order, isDelivered: true } : order
      );
      
      const updatedPendingOrders = this.state.pendingOrders.map(order =>
        order._id === orderId  && !order.isCancelled && !order.isDelivered && !order.isDeleted 
        ? { ...order, isDelivered: true } : order
      ).filter(order => !order.isCancelled && !order.isDelivered && !order.isDeleted);

      this.setState({
        liveOrdersToday: updatedLiveOrders,
        pendingOrders: updatedPendingOrders,
        loadingStatus: { ...this.state.loadingStatus, [orderId]: null } 
      });
  
    } catch (error) {
      messageShow(error.message || "Error updating delivery status");
      console.error("Error in handleDeliverStatusChange: ", error);
      this.setState(prevState => ({
        loadingStatus: { ...prevState.loadingStatus, [orderId]: null } 
      }));
    }
  };
  
  
  onCancel = (orderId) => async () => {
    const order = [...this.state.liveOrdersToday, ...this.state.pendingOrders].find(o => o._id === orderId);
    if (this.isCancelButtonDisabled(order)) {
      return;
    }
  
    let check = window.confirm("Are you sure you want to cancel this order?");
    
    if (check) {
      const { cancel, messageShow } = this.props;
  
      try {
        const response = await cancel({ orderId });
        if (response.data.success){
          messageShow(response.data.message);
        }
  
        const updatedLiveOrders = this.state.liveOrdersToday.map(order => {
          if (order._id === orderId) {
            return { ...order, isCancelled: true }; 
          }
          return order;
        });

        const updatedPendingOrders = this.state.pendingOrders.map(order => {
          if (order._id === orderId) {
            return { ...order, isCancelled: true }; 
          }
          return order;
        }).filter(order => !order.isCancelled && !order.isDelivered && !order.isDeleted);
  
        this.setState({ 
          liveOrdersToday: updatedLiveOrders,
          pendingOrders: updatedPendingOrders, 
        });
  
      } catch (error) {
        console.error("Error cancelling order: ", error);
        messageShow(error.message);
      }
    }
  };  
  
  onDelete = (orderId) => async () => {
    let check = window.confirm("Are you sure you want to delete this order?");
    
    if (check) {
      const { remove, messageShow } = this.props;
  
      try {
        const response = await remove({ orderId });
        if (response.data.success){
          messageShow(response.data.message);
        }

        const updatedLiveOrders = this.state.liveOrdersToday.map(order => {
          if (order._id === orderId) {
            return { ...order, isDeleted: true }; 
          }
          return order;
        }).filter(order => !order.isDeleted);

        const updatedPendingOrders = this.state.pendingOrders.map(order => {
          if (order._id === orderId) {
            return { ...order, isDeleted: true }; 
          }
          return order;
        }).filter(order => !order.isDeleted && !order.isCancelled && !order.isDelivered);
  
        this.setState({ 
          liveOrdersToday: updatedLiveOrders,
          pendingOrders: updatedPendingOrders
        });
  
      } catch (error) {
        console.error("Error deleting order: ", error);
        messageShow("Some error occurred. Please try again.");
      }
    }
  };
  
  handleToggleViewLive = () => {
    this.setState(prevState => ({ isVerticalLive: !prevState.isVerticalLive }));
  };
  handleToggleViewPending = () => {
    this.setState(prevState => ({ isVerticalPending: !prevState.isVerticalPending }));
  };    

  handleToggleOrder = (orderId) => {
    this.setState(prevState => ({
      activeOrder: prevState.activeOrder === orderId ? null : orderId, 
      areAllOrdersExpanded: false, 
    }));
  };
  
  handleToggleExpandAllLive = () => {
    this.setState(prevState => ({
      areAllOrdersExpandedLive: !prevState.areAllOrdersExpandedLive,
      activeOrder: null,
    }));
  };
  handleToggleExpandAllPending = () => {
    this.setState(prevState => ({
      areAllOrdersExpandedPending: !prevState.areAllOrdersExpandedPending,
      activeOrder: null,
    }));
  };
  handleOpenBarcodeModal = () => {
    this.setState({ barcodeModalOpen: true });
  };

  handleCloseBarcodeModal = () => {
    this.setState({ barcodeModalOpen: false });
  };

  handleOpenPreferenceModal = (preferences) => {
    this.setState({ 
      preferenceModalOpen: true,
      selectedPreferences: preferences
    });
  };

  handleClosePreferenceModal = () => {
    this.setState({ 
      preferenceModalOpen: false,
      selectedPreferences: ""
    });
  };


  openCouponPopover = (event, coupon) => {
    this.setState({
      anchorEl: event.currentTarget,  
      selectedCoupon: coupon,        
    });
  };
  
  closeCouponPopover = () => {
    this.setState({
      anchorEl: null,  
      selectedCoupon: null,
    });
  };
  handleFilterClickLive = (event) => {
    this.setState({ filterAnchorElLive: event.currentTarget });
  };
  handleFilterClickPending = (event) => {
    this.setState({ filterAnchorElPending: event.currentTarget });
  };  
  
  handleFilterChangeLive = (filterKey) => {
    this.setState((prevState) => ({
      tempFiltersLive: {
        ...prevState.tempFiltersLive,
        [filterKey]: !prevState.tempFiltersLive[filterKey],
      },
    }));
  };
  handleFilterChangePending = (filterKey) => {
    this.setState((prevState) => ({
      tempFiltersPending: {
        ...prevState.tempFiltersPending,
        [filterKey]: !prevState.tempFiltersPending[filterKey],
      },
    }));
  };    
  handleFilterClose = () => {
  this.setState({
    filterAnchorElLive: null,   
    filterAnchorElPending: null, 
  });
 };
 handleCheckboxChangeLive = (filterKey) => (event) => {
  this.setState((prevState) => ({
    tempFiltersLive: {
      ...prevState.tempFiltersLive,
      [filterKey]: event.target.checked,
    },
  }));
 };
 handleCheckboxChangePending = (filterKey) => (event) => {
  this.setState((prevState) => ({
    tempFiltersPending: {
      ...prevState.tempFiltersPending,
      [filterKey]: event.target.checked,
    },
  }));
 };  
  applyFiltersLive = () => {
    this.setState((prevState) => ({
      filtersLive: { ...prevState.tempFiltersLive },
      filterTypeLive: Object.values(prevState.tempFiltersLive).some((val) => val) ? "applied" : "",
    }));
    this.handleFilterClose();
  };
  applyFiltersPending = () => {
    this.setState((prevState) => ({
      filtersPending: { ...prevState.tempFiltersPending },
      filterTypePending: Object.values(prevState.tempFiltersPending).some((val) => val) ? "applied" : "",
    }));
    this.handleFilterClose();
  };        
  clearFiltersLive = () => {
    this.setState({
      tempFiltersLive: { inProgress: false, accepted: false, paid: false, dispatched: false, delivered: false, cancelled: false },
      filtersLive: { inProgress: false, accepted: false, paid: false, dispatched: false, delivered: false, cancelled: false },
      filterTypeLive: '',
    });
    this.handleFilterClose();
  };
  clearFiltersPending = () => {
    this.setState({
      tempFiltersPending: { inProgress: false, accepted: false, paid: false, dispatched: false, delivered: false, cancelled: false },
      filtersPending: { inProgress: false, accepted: false, paid: false, dispatched: false, delivered: false, cancelled: false },
      filterTypePending: '',
    });
    this.handleFilterClose();
  };      
   
  getButtonColor = (order) => {
    if (order.isCancelled || order.isDeleted) {
      return "#ff9999"; // Red color
    }
    if (!order.isOrderAccepted) {
      return "#ffb366"; // Orange color
    }
    if (order.paymentDetails?.status === "pending" && !order.isDispatched && !order.isDelivered) {
      return "#80b3ff"; // Blue color
    }
    if (order.paymentDetails?.status === "done" && order.deliveryMode === "HOME_DELIVERY" && order.isDispatched === false) {
      return "#80dfff"; // Cyan color
    }
    if (order.isDelivered === false && !order.isDispatched === false) {
      return "#80dfff"; // Green color
    }
    if (order.isDelivered) {
      return "#80cc80"; // Final delivered status color
    }
    return "#99e699"; 
  };
  

  handleToggleDispatchButton = (order) => {
    return order.deliveryMode === "HOME_DELIVERY" && order.paymentDetails?.status === "done" && !order.isDispatched;
  };
  isCancelButtonDisabled = (order) => {
    return order.isCancelled || 
          //  order.isOrderAccepted ||
           order.isDeleted || 
           order.paymentDetails?.status === "done" || 
           order.isDispatched || 
           order.isDelivered; 
  };
  getFilteredLiveOrders = (orders) => {
    const { filtersLive } = this.state;
    const activeFilters = Object.keys(filtersLive).filter((key) => filtersLive[key]);
  
    if (activeFilters.length === 0) return orders;
  
    return orders.filter((order) =>
      activeFilters.some((filterKey) => {
        switch (filterKey) {
          case "inProgress":
            return !order.isOrderAccepted && !order.isCancelled && !order.isDeleted;
          case "accepted":
            return order.isOrderAccepted && order.paymentDetails?.status === "pending" && !order.isDeleted;
          case "paid":
            return order.paymentDetails?.status === "done" && !order.isDispatched && !order.isDelivered;
          case "dispatched":
            return order.isDispatched && !order.isDelivered;
          case "delivered":
            return order.isDelivered;
          case "cancelled":
            return order.isCancelled;
          default:
            return false;
        }
      })
    );
  };
  
  getFilteredPendingOrders = (orders) => {
    const { filtersPending } = this.state;
    const activeFilters = Object.keys(filtersPending).filter((key) => filtersPending[key]);
  
    if (activeFilters.length === 0) return orders;
  
    return orders.filter((order) =>
      activeFilters.some((filterKey) => {
        switch (filterKey) {
          case "inProgress":
            return !order.isOrderAccepted && !order.isCancelled && !order.isDeleted;
          case "accepted":
            return order.isOrderAccepted && order.paymentDetails?.status === "pending" && !order.isDeleted;
          case "paid":
            return order.paymentDetails?.status === "done" && !order.isDispatched && !order.isDelivered;
          case "dispatched":
            return order.isDispatched && !order.isDelivered;
          case "delivered":
            return order.isDelivered;
          case "cancelled":
            return order.isCancelled;
          default:
            return false;
        }
      })
    );
  }; 
  
  handleTogglePendingOrders = () => {
     const { match } = this.props;
    this.setState(
      prev => ({ showPendingOrders: !prev.showPendingOrders }),
      () => {
        if (this.state.showPendingOrders && !this.state.pendingLoadedOnce) {
          const newPage = parseInt(match.params.page) || 1;
          this.setState({ page: newPage }, () => {
            this.fetchPendingOrders(newPage);
        });
        }
      }
    );
  };

  toggleSelectionMode = () => {
    this.setState(prev => ({ 
      isSelectionMode: !prev.isSelectionMode,
      selectedPendingOrders: [],
      isAllSelectedAcrossPages: false
    }));
  };

  handleSelectPendingOrder = (orderId) => {
    this.setState((prevState) => {
      const selectedPendingOrders = [...prevState.selectedPendingOrders];
      const index = selectedPendingOrders.indexOf(orderId);
      if (index > -1) {
        selectedPendingOrders.splice(index, 1);
      } else {
        selectedPendingOrders.push(orderId);
      }
      return { 
        selectedPendingOrders,
        isAllSelectedAcrossPages: false 
      };
    });
  };

  handleSelectAllPendingOrders = (event) => {
    const { pendingOrders } = this.state;
    const pendingOrdersFiltered = this.getFilteredPendingOrders(pendingOrders || []);

    if (event.target.checked) {
      const allIds = pendingOrdersFiltered.map((o) => o._id);
      this.setState({ 
        selectedPendingOrders: allIds,
        isAllSelectedAcrossPages: false
      });
    } else {
      this.setState({ 
        selectedPendingOrders: [],
        isAllSelectedAcrossPages: false
      });
    }
  };

  handleSelectAllAcrossPages = async () => {
    const { getPendingOrders, messageShow } = this.props;
    const { count } = this.state;

    try {
      this.setState({ pendingLoading: true });
      // Fetch all pending orders by setting limit to total count
      const response = await getPendingOrders(1, count);
      const allOrders = response?.data?.data?.pendingOrders || [];
      const allIds = allOrders.map(o => o._id);

      this.setState({
        selectedPendingOrders: allIds,
        isAllSelectedAcrossPages: true,
        pendingLoading: false
      });
    } catch (error) {
      console.error("Error selecting all orders across pages:", error);
      messageShow("Failed to select all orders. Please try again.");
      this.setState({ pendingLoading: false });
    }
  };

  handleBulkDeliverPendingOrders = async () => {
    const { selectedPendingOrders } = this.state;
    if (selectedPendingOrders.length === 0) return;

    const confirmDeliver = window.confirm(
      `Are you sure you want to mark ${selectedPendingOrders.length} orders as delivered?`
    );
    if (!confirmDeliver) return;

    const { deliverToggle, messageShow } = this.props;

    try {
      this.setState({ pendingLoading: true });
      
      const response = await deliverToggle({ orderIds: selectedPendingOrders, isDelivered: true });

      if (response.data.success){
        messageShow(`${selectedPendingOrders.length} orders marked as delivered successfully.`);
      }

      this.fetchPendingOrders(this.state.page);

      this.setState({
        selectedPendingOrders: [],
        isSelectionMode: false,
        isAllSelectedAcrossPages: false
      });

    } catch (error) {
      console.log("Bulk deliver error:", error);
      messageShow("Failed to update some orders. Please try again.");
      this.setState({ pendingLoading: false });
      this.fetchPendingOrders(this.state.page);
    }
  };
  
  render() {
    const { isLoading, hasLoadedOnce, liveOrdersToday,pendingOrders, showPendingOrders, pendingLoading, pendingLoadedOnce, currencySymbol, activeOrder,filterTypeLive,filterTypePending,isVerticalLive,isVerticalPending,areAllOrdersExpandedLive,areAllOrdersExpandedPending, barcodeModalOpen,anchorEl, selectedPendingOrders, isSelectionMode, isAllSelectedAcrossPages, permissions, settingsData } = this.state;
    const liveOrdersFiltered = this.getFilteredLiveOrders(liveOrdersToday  || []);
    const pendingOrdersFiltered = this.getFilteredPendingOrders(pendingOrders  || []);
    
    return (
      <>
      <SectionPaper>
        <div style={{ padding: "2px 0" }}>
          <Typography variant="h6" sx={{ marginLeft: "20px", padding: "10px 0", }}>
            Live Orders for Today : {dayjs().format("DD-MM-YYYY")}
          </Typography>
        {/* Icons for Expand All, View Toggle */}
        <div style={{ display: "flex", justifyContent: "flex-end", padding: "2px", gap: "10px" }}>
        <Tooltip title="Filter Live Orders" arrow>
          <IconButton
            onClick={this.handleFilterClickLive}
            color={filterTypeLive !== '' ? 'primary' : 'default'} 
            sx={{
              transform: "scaleX(1.2)",
              fontSize: 27,
              backgroundColor: filterTypeLive !== '' ? 'rgba(0, 123, 255, 0.2)' : 'transparent', 
              '&:hover': { backgroundColor: filterTypeLive !== '' ? 'rgba(0, 123, 255, 0.3)' : 'transparent' },
            }}
          >
            <FilterListIcon sx={{ color: filterTypeLive !== '' ? 'primary.main' : 'primary.main' }} />
          </IconButton>
        </Tooltip>
        {/* Menu to display filter options */}
        <Menu
          anchorEl={this.state.filterAnchorElLive}
          open={Boolean(this.state.filterAnchorElLive)}
          onClose={this.handleFilterClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        >
          {/* Filter menu items */}
          <MenuItem>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.tempFiltersLive.inProgress}
                  onChange={this.handleCheckboxChangeLive('inProgress')}
                />
              }
              label="In Progress Orders"
            />
          </MenuItem>
          <MenuItem>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.tempFiltersLive.accepted}
                  onChange={this.handleCheckboxChangeLive('accepted')}
                />
              }
              label="Accepted Orders"
            />
          </MenuItem>
          <MenuItem>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.tempFiltersLive.paid}
                  onChange={this.handleCheckboxChangeLive('paid')}
                />
              }
              label="Paid Orders"
            />
          </MenuItem>
          <MenuItem>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.tempFiltersLive.dispatched}
                  onChange={this.handleCheckboxChangeLive('dispatched')}
                />
              }
              label="Dispatched Orders"
            />
          </MenuItem>
          <MenuItem>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.tempFiltersLive.delivered}
                  onChange={this.handleCheckboxChangeLive('delivered')}
                />
              }
              label="Delivered Orders"
            />
          </MenuItem>
          <MenuItem>
            <FormControlLabel
              control={
                <Checkbox
                  checked={this.state.tempFiltersLive.cancelled}
                  onChange={this.handleCheckboxChangeLive('cancelled')}
                />
              }
              label="Cancelled Orders"
            />
          </MenuItem>          
          <MenuItem disableRipple disableTouchRipple>
           <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px' }}>
            <Button
              color="primary"
              variant="contained"
              size="small"
              style={{ marginRight: '8px', fontSize: '0.75rem' }}
              onClick={this.applyFiltersLive}
            >
              Apply
            </Button>
            <Button
              color="error"
              variant="contained"
              size="small"
              sx={{ fontSize: '0.75rem' }}
              onClick={this.clearFiltersLive}
            >
              Clear
            </Button>
           </div>
          </MenuItem>
        </Menu>
          {/* Expand/Collapse Button */}
          <Tooltip title={areAllOrdersExpandedLive ? "Collapse All" : "Expand All"} arrow>
          <IconButton onClick={this.handleToggleExpandAllLive} color="primary">
            {areAllOrdersExpandedLive ? <CloseFullscreenIcon /> : <OpenInFullIcon />}
          </IconButton>
          </Tooltip>

          {/* View Toggle */}
          <Tooltip title={isVerticalLive ? "Horizontal View" : "Vertical View"} arrow>
          <IconButton onClick={this.handleToggleViewLive} color="primary">
            {isVerticalLive ? <GridViewIcon /> : <ViewAgendaIcon />}
          </IconButton>
          </Tooltip>
        </div>
        
        <button 
          id="refreshLiveOrders" 
          style={{ display: "none" }} 
          onClick={() => this.fetchLiveOrders()}
        />
        {isLoading || !hasLoadedOnce ? (
          <BrandedLoading />
        ) : !isLoading && hasLoadedOnce && liveOrdersFiltered.length === 0 ? (
          <EmptyMessage message="No live orders for today." />
        ) : (
          <div style={{
            display: "flex",
            flexDirection: isVerticalLive || window.innerWidth <= 600 ? "column" : "row",
            justifyContent: isVerticalLive ? "center" : "flex-start",
            alignItems: isVerticalLive ? "center" : "stretch",
            gap: "20px",
            flexWrap: isVerticalLive ? "nowrap" : "wrap",
            padding: "12px",
          }}>
            {liveOrdersFiltered.map(order => {
              const buttonColor = this.getButtonColor(order);
              const isCancelDisabled = this.isCancelButtonDisabled(order);
              const isExpanded = areAllOrdersExpandedLive || activeOrder === order._id;

              return (
                <Card key={order._id} sx={{
                  marginBottom: 2,
                  borderRadius: "20px",
                  boxShadow: 3,
                  overflow: "hidden",
                  width: "285px",
                  textAlign: "center",
                  height: isExpanded ? "auto" : "48px", 
                  display: "flex",              
                  flexDirection: "column",      
                  justifyContent: "space-between", 
                  "@media (max-width: 600px)": {
                    width: "100%", 
                  },
                }}>
                  <Button
                    sx={{
                      backgroundColor: isExpanded ? "white" : buttonColor,
                      color: isExpanded ? "black" : "black",
                      fontWeight: "bold",
                      fontSize: "14px",
                      textTransform: "none",
                      display: "flex",
                      justifyContent: "flex-start",
                      alignItems: "center",
                      width: "100%",
                      borderRadius: "20px",
                      padding: "12px 0 12px 14px", 
                      "@media (max-width: 600px)": {
                        fontSize: "10px",
                        padding: "10px",
                        height: "50px", 
                      },
                      "&:hover": { backgroundColor: activeOrder === order._id ? "white" : buttonColor, boxShadow: "none" },
                    }}
                    onClick={() => this.handleToggleOrder(order._id)}
                  >
                    {/* Conditional rendering of avatar or icon based on delivery mode */}
                    {order.deliveryMode === "STORE_PICKUP" ? (
                      <StorefrontIcon 
                        sx={{ 
                        width: 24, 
                        height: 24, 
                        marginRight: 3,
                        "@media (max-width: 600px)": {
                            margin: "0 4px", 
                            display: "block"
                          } 
                      }} />
                    ) : order.deliveryMode === "HOME_DELIVERY" ? (
                      <HomeIcon 
                        sx={{ 
                        width: 24, 
                        height: 24, 
                        marginRight: 3, 
                        "@media (max-width: 600px)": {
                          margin: "0 4px", 
                          display: "block",
                        } 
                      }} />
                    ) : (
                      <Avatar src={order.platformLogo} sx={{ width: 24, height: 24, marginRight: 1 }} />
                    )}
                    <Typography fontWeight="bold" 
                      sx={{
                        whiteSpace: "normal", 
                        wordBreak: "break-word",
                        "@media (max-width: 600px)": {
                          fontSize: "14px",
                          padding: "0 10px",
                        }
                      }}
                    >
                      #{`${order.id} | ${dayjs(order.createdAt).format("hh:mm A")}`}
                    </Typography>
                    {/*order.isDelivered&& (
                      <CheckCircleIcon
                        sx={{
                          position: "absolute",
                          right: 8, 
                          top: 15,
                          "@media (max-width: 600px)": {
                            top: 19,
                            fontSize: "16px",  
                          },  
                          color: isExpanded ? "black" : "white", 
                          fontSize: "18px", 
                        }}
                      />
                    )}
                    {order.isCancelled && (
                      <CancelIcon
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 15,
                        "@media (max-width: 600px)": {
                            top: 19,
                            fontSize: "16px",  
                          },
                        color: isExpanded ? "black" : "white",
                        fontSize: "18px",
                      }}
                    />
                    )}
                    
                    {/* Status icons in right corner */}
                    {/*order.paymentId?.status === "pending" && !order.isOrderAccepted && !order.isCancelled && (
                      <AccessTimeIcon
                        sx={{
                          position: "absolute",
                          right: 8,
                          top: 15,
                          "@media (max-width: 600px)": {
                            top: 18,
                            fontSize: "16px",  
                          },
                          color: isExpanded ? "black" : "white",
                          fontSize: "18px",
                        }}
                      />
                    )}
                    {order.isOrderAccepted && !order.isDelivered && !order.isCancelled && !order.isDispatched && order.paymentId?.status === "pending"  && (
                    <Box 
                      sx={{ 
                      position: "absolute", 
                      right: 8, 
                      top: 13,
                      "@media (max-width: 600px)": {
                            top: 17, 
                            fontSize: "10px", 
                          }, 
                      }}>
                      <ArticleIcon
                        sx={{
                          color: isExpanded ? "black" : "white",
                          fontSize: "18px",
                          "@media (max-width: 600px)": {
                            fontSize: "16px", 
                          },
                        }}
                      />
                      <CheckIcon
                        sx={{
                          position: "absolute",
                          right: "-1px",
                          bottom: "-1px",
                          color: isExpanded ? "grey" : "black",
                          fontSize: "17px",
                          "@media (max-width: 600px)": {
                            fontSize: "14px", 
                          },
                          fontWeight: "bold",
                        }}
                      />
                    </Box>
                  )}
                  {order.paymentId?.status === "done" && !order.isDelivered && !order.isDispatched && (
                      <MonetizationOnIcon
                        sx={{
                          position: "absolute",
                          right: 8,
                          top: 15,
                          "@media (max-width: 600px)": {
                            top: 19,
                            fontSize: "15px", 
                          },
                          color: isExpanded ? "black" : "white",
                          fontSize: "18px",
                        }}
                      />
                    )}
                    {order.deliveryMode === "HOME_DELIVERY" && order.isDispatched === true && !order.isDelivered && order.paymentId?.status === "done" && (
                    <LocalShippingIcon
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 15,
                        "@media (max-width: 600px)": {
                            top: 19,
                            fontSize: "16px",
                          },
                        color: isExpanded ? "black" : "white",
                        fontSize: "18px",
                      }}
                    />
                  )*/}

                  </Button>

                  <Collapse in={isExpanded}>
                    <CardContent sx={{ borderRadius: "12px", padding: "10px",maxHeight: "480px", backgroundColor: "white", marginTop: 'auto' }}>
                    <CardContent sx={{ borderRadius: "12px", padding: "10px", backgroundColor: "white", maxHeight: "300px", overflowY: "auto", marginTop: 'auto' }}>

                    <div style={{display: "flex-end",borderBottom: "1px solid #ddd", paddingBottom: "5px"}}>
                    <div style={{ display: "flex", justifyContent: "flex-start", fontWeight: "bold", fontSize: "12px",  }}>
                      <span>Name: {order.userDetails?.name || "Guest User"}, </span>
                    </div> 
                    <div style={{ display: "flex", justifyContent: "flex-start", fontWeight: "bold", fontSize: "12px",  }}>                       
                      <span>Mobile: {order.userDetails?.mobile || ""}</span>
                    </div>
                    <div style={{display: "flex", justifyContent: "flex-start",fontWeight: "bold", fontSize: "12px"}}>
                      <span>Address: {order.addressDetails?.street1 || "No Address"} {order.addressDetails?.pincode || ""}</span>
                    </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-start", fontWeight: "bold", fontSize: "12px",  }}>                       
                      <span>Status: {order.paymentDetails?.status === "done" ? 'paid' : 'unpaid'}</span>
                    </div>
                    <hr style={{ margin: "8px 0", borderColor: "#ddd", borderTop: "1px solid grey" }} />
                      {/* Display order items */}
                      <div style={{ width: "100%", marginBottom: "10px" }}>
                        <div style={{ 
                           display: "flex", 
                           justifyContent: "space-between", 
                           fontWeight: "bold", fontSize: "12px", 
                           borderBottom: "1px solid #ddd", 
                           paddingBottom: "5px",
                           "@media (max-width: 600px)": {
                            fontSize: "10px",
                            paddingBottom: "10px", 
                          } 
                           }}>
                          <span style={{ width: "30%", textAlign: "left" }}>Product</span>
                          <span style={{ width: "10%", textAlign: "left" }}>Quantity</span>
                          <span style={{ width: "18%", textAlign: "left" }}>Price</span>
                        </div>
                        {Object.values(order.cartrequest || []).map((item, index) => (
                          <div key={index} style={{ display: "flex", justifyContent: "space-between", padding: "0.5px 0", fontSize: "12px" }}>
                            <span style={{ width: "30%", textAlign: "left" }}>{item?.name || "Unknown Product"}</span>
                            <span style={{ width: "10%" }}>{item.count}</span>
                            <span style={{ width: "18%", textAlign: "left" }}>
                              {currencySymbol}{" "}{((order.orderFrom === "instore" ? item.storePrice : (item.priceDiscount > 0 ? item.priceDiscounted : item.price)) * item.count).toFixed(2)}
                            </span>
                          </div>
                        ))}
                        {/* Handling Free Product Display */}
                        {order?.freeProducts && order.freeProducts.map((freeProduct, index) => (
                          <div key={index} style={{ display: "flex", justifyContent: "space-between", padding: "0.5px 0", fontSize: "12px", fontWeight: "bold" }}>
                            <span style={{ width: "30%", textAlign: "left" }}>
                              {freeProduct.name || "Free Product"}
                            </span>
                            <span style={{ width: "10%" }}>
                            </span>
                            <span style={{ width: "18%", textAlign: "left", color: "red" }}>
                              Free
                            </span>
                          </div>
                        ))}
                      </div>
                      <hr style={{ margin: "8px 0", borderColor: "#ddd", borderTop: "1px solid grey" }} />
                      <Typography fontSize={13} sx={{ display: "flex", justifyContent: "space-between" }}>
                        <span>Subtotal:</span>
                        <span>{currencySymbol} {order.amountTotal || 0}</span>
                      </Typography>
                      <Typography fontSize={13} sx={{ display: "flex", justifyContent: "space-between" }}>
                        <span>Delivery:</span>
                        <span>
                          {currencySymbol} 
                          {(!isNaN(order.deliveryCharge))  
                              ? Number(order.deliveryCharge).toFixed(2) 
                              : '0.00'}
                        </span>
                      </Typography>
                      <Typography fontSize={13} sx={{ display: "flex", justifyContent: "space-between" }}>
                        <span>Tax:</span>
                        <span>{currencySymbol} {(parseFloat(order.taxAmount) || 0).toFixed(2)}</span>
                      </Typography>
                      <Typography fontSize={13} sx={{ display: "flex", justifyContent: "space-between" }}>
                        <span>Discount:</span>
                        <span>{currencySymbol} {(parseFloat(order.discount) || 0).toFixed(2)}</span>
                      </Typography>
                      <Typography fontSize={13} sx={{ display: "flex", justifyContent: "space-between" }}>
                        <span>Other Charges:</span>
                        <span>{currencySymbol} {(parseFloat(order.otherCharges) || 0).toFixed(2)}</span>
                      </Typography>
                      <hr style={{ margin: "8px 0", borderColor: "#ddd", borderTop: "1px solid grey" }} />
                      {order.redeemedCouponDetails && (
                        <Typography 
                          fontSize={13} 
                          sx={{ display: "flex", justifyContent: "space-between", color: "green", cursor: "pointer" }} 
                          onClick={(event) => this.openCouponPopover(event, order.redeemedCouponDetails)}
                        >
                          <span>Coupon Applied:</span>
                          <span>{order.redeemedCouponDetails.voucherCode || null}</span>
                        </Typography>
                      )}
                      <Typography fontSize={14} fontWeight="bold" sx={{ display: "flex", justifyContent: "space-between", marginTop: "8px" }}>
                        <span>Total: </span>
                        <span>{currencySymbol} {order.grandTotal || 0}</span>
                      </Typography>
                      </CardContent>
                      {order.uberDelivery && order.uberDelivery?.deliveryStatus && (
                        <div style={{ marginTop: "10px", fontSize: "13px", }}>
                          Uber Delivery Status: {order.uberDelivery?.deliveryStatus}
                        </div>
                      )} 

                      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', marginTop: 'auto' }}>
  
                        <div style={{ display: 'flex', gap: '4px' }}>
                          {/* Delete Button */}
                          <Tooltip title={order.paymentDetails?.status === "done" ? "Cannot delete at this stage" : "Delete"} arrow>
                            <IconButton color="error" onClick={order.paymentDetails?.status !== "done" ? this.onDelete(order._id) : null} disabled={!permissions.canDelete}>
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                          
                          {/* Cancel Button */}
                          <Tooltip title={isCancelDisabled ? "Cannot cancel at this stage" : "Cancel"} arrow>
                            <IconButton sx={{ color: "grey" }} onClick={this.onCancel(order._id)} disabled={!permissions.canDelete}>
                              <CancelIcon />
                            </IconButton>
                          </Tooltip>

                          {/* Preferences Button */}
                          {order.preferences && (
                            <Tooltip title="View Customer Preferences" arrow>
                              <IconButton 
                                color="primary"
                                onClick={() => this.handleOpenPreferenceModal(order.preferences)}
                              >
                                <ArticleIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                        </div>
   
                        <div style={{ display: 'flex', gap: '4px' }}>
                        {order.uberDelivery && order.uberDelivery?.trackingUrl && (
                          <Tooltip title="Delivery Status URL" arrow>
                            <IconButton
                              color="primary"
                              onClick={() => {
                                if (permissions.canEdit) {
                                  window.open(order.uberDelivery?.trackingUrl, "_blank");
                                }
                              }}
                              disabled={!permissions.canEdit}
                            >
                              <DirectionsCar />
                            </IconButton>
                          </Tooltip>
                        )}
                          {/* Print Button */}
                        {permissions.canEdit ? (
                          <Tooltip title="Print" arrow>
                            <Link to={routes.orderPrint.path(order._id)}>
                              <IconButton color="primary">
                                <PrintIcon />
                              </IconButton>
                            </Link>
                          </Tooltip>
                          ) : (
                            <IconButton color="primary" disabled>
                              <PrintIcon />
                            </IconButton>
                        )}
                          
                          {/* Barcode (Scanner) Button */}
                        <Tooltip title="View QR payment" arrow>
                          <span>
                            <IconButton 
                              sx={{ color: "black", fontWeight: "bold", backgroundColor: "transparent", "&:hover": { color: "#000" } }} 
                              onClick={this.handleOpenBarcodeModal}
                              disabled
                            >
                              <QrCodeIcon />
                            </IconButton>
                          </span>
                        </Tooltip>
                        </div>

                      </div>
                      
                      <Tooltip
                        title={
                          this.state.loadingStatus[order._id] === "In Progress" ||
                          (order.paymentDetails?.status === "done" &&
                           order.deliveryMode === "HOME_DELIVERY" &&
                           order.isDispatched &&
                           order?.isUberDelivery &&
                           order.uberDelivery?.deliveryStatus !== "delivered")
                           ? "Click to get Uber delivery status"
                           : ""
                        }
                        disableHoverListener={
                        !( this.state.loadingStatus[order._id] === "In Progress" ||
                          (order.paymentDetails?.status === "done" &&
                           order.deliveryMode === "HOME_DELIVERY" &&
                           order.isDispatched &&
                           order?.isUberDelivery &&
                           order.uberDelivery?.deliveryStatus !== "delivered")
                          )
                        }
                      >
                      <Button
                        sx={{
                          backgroundColor: order.isCancelled
                            ? "#ffb3b3" // Light red
                            : !order.isOrderAccepted
                            ? "#99c2ff" 
                            : order.paymentDetails?.status === "pending" && !order.isDispatched && !order.isDelivered
                            ? "#99e6ff" 
                            : order.paymentDetails?.status === "done" && order.deliveryMode === "HOME_DELIVERY" && order.isDispatched === false
                            ? "#99e6ff"
                            : order.isDelivered === false && !order.isDispatched === false
                            ? "#99e699" 
                            : "#99e699",
                          color: "black", 
                          marginTop: "2px",
                          padding: "4px",
                          borderRadius: "20px",
                          fontSize: "14px",
                          fontWeight: "bold",
                          width: "50%",
                          border: `2px solid ${
                            order.isCancelled
                              ? "#ff9999" 
                              : !order.isOrderAccepted
                              ? "#80b3ff" 
                              : order.paymentDetails?.status === "pending" && !order.isDispatched && !order.isDelivered
                              ? "#80dfff" 
                              : order.paymentDetails?.status === "done" && order.deliveryMode === "HOME_DELIVERY" && order.isDispatched === false
                              ? "#80dfff" 
                              : order.isDelivered === false && !order.isDispatched === false
                              ? "#80cc80" 
                              : "#80cc80"
                          }`, 
                          "&:hover": {
                            backgroundColor: order.isCancelled
                              ? "#ff9999" 
                              : !order.isOrderAccepted
                              ? "#80b3ff"
                              : order.paymentDetails?.status === "pending" && !order.isDispatched && !order.isDelivered
                              ? "#80dfff"
                              : order.paymentDetails?.status === "done" && order.deliveryMode === "HOME_DELIVERY" && order.isDispatched === false
                              ? "#80dfff" 
                              : order.isDelivered === false && !order.isDispatched === false
                              ? "#80cc80" 
                              : "#80cc80",
                            border: `2px solid ${
                              order.isCancelled
                                ? "#ff6666" 
                                : !order.isOrderAccepted
                                ? "#6699ff" 
                                : order.paymentDetails?.status === "pending" && !order.isDispatched && !order.isDelivered
                                ? "#66c2ff" 
                                : order.paymentDetails?.status === "done" && order.deliveryMode === "HOME_DELIVERY" && order.isDispatched === false
                                ? "#66c2ff" 
                                : order.isDelivered === false && !order.isDispatched === false
                                ? "#66b366" 
                                : "#66b366"
                            }`, 
                          },
                        }}
                        onClick={() => {
                          if (!order.isCancelled) {
                            if (!order.isOrderAccepted) {
                              this.handleOrderStatusChange(order._id, order.isOrderAccepted);
                            } else if (order.paymentDetails?.status !== "done") {
                              this.handlePaidStatusChange(order._id, order.paymentDetails?.status);
                            } else if (order.paymentDetails?.status === "done" && order.deliveryMode === "STORE_PICKUP") {
                              this.handleDeliverStatusChange(order._id);
                            } else if (order.paymentDetails?.status === "done" && order.deliveryMode === "HOME_DELIVERY" && !order.isDispatched) {
                              this.handleDispatchStatusChange(order._id);
                            } else if (order.isDispatched && !order.isDelivered) {
                              if (order?.isUberDelivery && order.uberDelivery?.deliveryStatus !== "delivered") {
                                this.handleOrderClick(order);
                              } else {
                                this.handleDeliverStatusChange(order._id);
                              }
                            }
                          }
                        }}
                        disabled={order.isCancelled || order.isDelivered || (order.isDispatched && order.deliveryMode === "HOME_DELIVERY" && order.isDelivered) || !this.state.permissions.canEdit}
                      >
                        {this.state.loadingStatus[order._id] ||
                          (order.isCancelled
                            ? "Cancelled"
                            : order.isDelivered
                            ? "Delivered"
                            : !order.isOrderAccepted
                            ? "Accept"
                            : order.paymentDetails?.status === "done"
                            ? order.deliveryMode === "STORE_PICKUP"
                              ? "Deliver"
                              : order.isDispatched
                              ? order?.isUberDelivery && order.uberDelivery?.deliveryStatus !== "delivered"
                                ? "In Progress"
                                : "Deliver"
                              : "Dispatch"
                            : "Paid")}
                      </Button>
                      </Tooltip>
                    </CardContent>
                  </Collapse>
                </Card>
              );
            })}

          </div>
        )}
        </div>
        <div>
        <div style={{ display: "flex", alignItems: "center", marginTop: "20px" }}>
          <Typography variant="h6" sx={{ marginLeft: "20px", padding: "1px 0", }}>
            Pending Orders :
          </Typography>
           <IconButton onClick={this.handleTogglePendingOrders}>
            {showPendingOrders ? <ExpandLessIcon /> : <ExpandMoreIcon />}
          </IconButton>
        </div>
        {showPendingOrders && (
        <>
        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginBottom: "10px", alignItems: 'center' }}>
          <Tooltip title={isSelectionMode ? "Cancel Selection Mode" : "Bulk Deliver Orders"}>
            <IconButton onClick={this.toggleSelectionMode} color="primary" disabled={!permissions.canEdit}>
              <LocalShippingIcon />
            </IconButton>
          </Tooltip>

          {isSelectionMode && (
            <div style={{ 
              display: 'flex', 
              flexDirection: 'column',
              backgroundColor: '#f5f5f5', 
              borderRadius: '4px', 
              padding: '4px 8px',
              border: '1px solid #e0e0e0'
            }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={
                        (pendingOrdersFiltered.length > 0 &&
                          selectedPendingOrders.length === pendingOrdersFiltered.length) || isAllSelectedAcrossPages
                      }
                      indeterminate={
                        selectedPendingOrders.length > 0 &&
                        selectedPendingOrders.length < pendingOrdersFiltered.length && !isAllSelectedAcrossPages
                      }
                      onChange={this.handleSelectAllPendingOrders}
                      color="primary"
                      size="small"
                    />
                  }
                  label={<Typography variant="body2" style={{fontSize: '13px'}}>Select All</Typography>}
                  style={{ marginRight: '8px' }}
                />
                  <Button 
                    onClick={this.handleBulkDeliverPendingOrders} 
                    color="success" 
                    variant="contained" 
                    size="small"
                    disabled={selectedPendingOrders.length === 0}
                    sx={{ fontSize: '11px', padding: '4px 10px', minWidth: 'auto' }}
                  >
                    Deliver ({selectedPendingOrders.length})
                  </Button>
              </div>
              {selectedPendingOrders.length === pendingOrdersFiltered.length && 
                pendingOrdersFiltered.length < this.state.count && 
                !isAllSelectedAcrossPages && (
                  <div style={{ padding: '4px 0', fontSize: '11px', borderTop: '1px solid #e0e0e0', marginTop: '4px' }}>
                    All {selectedPendingOrders.length} orders on this page are selected. 
                    <span 
                      style={{ color: '#1976d2', cursor: 'pointer', fontWeight: 'bold', marginLeft: '5px', textDecoration: 'underline' }}
                      onClick={this.handleSelectAllAcrossPages}
                    >
                      Select all {this.state.count} orders in Pending
                    </span>
                  </div>
              )}
              {isAllSelectedAcrossPages && (
                <div style={{ padding: '4px 0', fontSize: '11px', borderTop: '1px solid #e0e0e0', marginTop: '4px' }}>
                  All {this.state.count} orders in Pending are selected. 
                  <span 
                    style={{ color: '#1976d2', cursor: 'pointer', fontWeight: 'bold', marginLeft: '5px', textDecoration: 'underline' }}
                      onClick={() => this.setState({ selectedPendingOrders: [], isAllSelectedAcrossPages: false })}
                  >
                    Clear selection
                  </span>
                </div>
              )}
            </div>
          )}

          {/* Pending Orders Filter */}
          <Tooltip title="Filter Pending Orders" arrow>
            <IconButton
              onClick={this.handleFilterClickPending}
              color={filterTypePending !== '' ? 'primary' : 'default'}
              sx={{
                transform: "scaleX(1.2)",
                fontSize: 27,
                backgroundColor: filterTypePending !== '' ? 'rgba(0, 123, 255, 0.2)' : 'transparent',
                '&:hover': { backgroundColor: filterTypePending !== '' ? 'rgba(0, 123, 255, 0.3)' : 'transparent' },
              }}
            >
              <FilterListIcon sx={{ color: filterTypePending !== '' ? 'primary.main' : 'primary.main' }} />
            </IconButton>
          </Tooltip>
          {/* Menu to display filter options */}
          <Menu
            anchorEl={this.state.filterAnchorElPending}
            open={Boolean(this.state.filterAnchorElPending)}
            onClose={this.handleFilterClose}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            {/* Filter menu items */}
            <MenuItem>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.tempFiltersPending.inProgress}
                    onChange={this.handleCheckboxChangePending('inProgress')}
                  />
                }
                label="In Progress Orders"
              />
            </MenuItem>
            <MenuItem>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.tempFiltersPending.accepted}
                    onChange={this.handleCheckboxChangePending('accepted')}
                  />
                }
                label="Accepted Orders"
              />
            </MenuItem>
            <MenuItem>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.tempFiltersPending.paid}
                    onChange={this.handleCheckboxChangePending('paid')}
                  />
                }
                label="Paid Orders"
              />
            </MenuItem>
            <MenuItem>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.tempFiltersPending.dispatched}
                    onChange={this.handleCheckboxChangePending('dispatched')}
                  />
                }
                label="Dispatched Orders"
              />
            </MenuItem>
            <MenuItem>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.tempFiltersPending.delivered}
                    onChange={this.handleCheckboxChangePending('delivered')}
                  />
                }
                label="Delivered Orders"
              />
            </MenuItem>
            <MenuItem>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={this.state.tempFiltersPending.cancelled}
                    onChange={this.handleCheckboxChangePending('cancelled')}
                  />
                }
                label="Cancelled Orders"
              />
            </MenuItem>          
            <MenuItem disableRipple disableTouchRipple>
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '8px' }}>
              <Button
                color="primary"
                variant="contained"
                size="small"
                style={{ marginRight: '8px', fontSize: '0.75rem' }}
                onClick={this.applyFiltersPending}
              >
                Apply
              </Button>
              <Button
                color="error"
                variant="contained"
                size="small"
                sx={{ fontSize: '0.75rem' }}
                onClick={this.clearFiltersPending}
              >
                Clear
              </Button>
            </div>
            </MenuItem>
          </Menu>
          {/* Expand/Collapse Button for Pending Orders */}
          <Tooltip title={areAllOrdersExpandedPending ? "Collapse All" : "Expand All"} arrow>
            <IconButton onClick={this.handleToggleExpandAllPending} color="primary">
              {areAllOrdersExpandedPending ? <CloseFullscreenIcon /> : <OpenInFullIcon />}
            </IconButton>
          </Tooltip>

          {/* View Toggle for Pending Orders */}
          <Tooltip enterDelay={500} title={isVerticalPending ? "Horizontal View" : "Vertical View"} arrow>
            <IconButton onClick={this.handleToggleViewPending} color="primary">
              {isVerticalPending ? <GridViewIcon /> : <ViewAgendaIcon />}
            </IconButton>
          </Tooltip>
        </div>
        {pendingLoading  || !pendingLoadedOnce? (
          <BrandedLoading />
        ) : !isLoading && pendingLoadedOnce && pendingOrdersFiltered.length === 0 ? (
          <EmptyMessage message="No Pending Orders." />
        ) : (
          <div style={{
            display: "flex",
            flexDirection: isVerticalPending || window.innerWidth <= 600 ? "column" : "row",
            justifyContent: isVerticalPending ? "center" : "flex-start",
            alignItems: isVerticalPending ? "center" : "stretch",
            gap: "20px",
            flexWrap: isVerticalPending ? "nowrap" : "wrap",
            padding: "12px",
          }}>
           {pendingOrdersFiltered.map(order => {
              const buttonColor = this.getButtonColor(order);
              const isCancelDisabled = this.isCancelButtonDisabled(order);
              const isExpanded = areAllOrdersExpandedPending || activeOrder === order._id;

              return (
                <Box key={order._id} sx={{ 
                  display: 'flex', 
                  alignItems: 'flex-start',
                  marginBottom: 2,
                  "@media (max-width: 600px)": {
                    width: "100%", 
                  },
                }}>
                  {isSelectionMode && (
                     <Checkbox
                      checked={this.state.selectedPendingOrders.includes(order._id)}
                      onClick={(e) => {
                        e.stopPropagation();
                        this.handleSelectPendingOrder(order._id);
                      }}
                      color="primary"
                      sx={{ marginTop: 1, marginRight: 1 }}
                    />
                  )}
                <Card sx={{
                  borderRadius: "20px",
                  boxShadow: 3,
                  overflow: "hidden",
                  width: "289px",
                  textAlign: "center",
                  height: isExpanded ? "auto" : "50px", 
                  display: "flex",              
                  flexDirection: "column",      
                  justifyContent: "space-between",
                  // marginBottom: 2 // Handled by wrapper
                  "@media (max-width: 600px)": {
                    width: "100%", 
                  },
                }}>
                  <Button
                    sx={{
                      backgroundColor: isExpanded ? "white" : buttonColor,
                      color: isExpanded ? "black" : "black",
                      fontWeight: "bold",
                      fontSize: "13px",
                      textTransform: "none",
                      display: "flex",
                      justifyContent: "space-between",
                      //alignItems: "center",
                      width: "100%",
                      borderRadius: "20px",
                      height: "55px", 
                      "@media (max-width: 600px)": {
                        fontSize: "10px",
                        padding: "1px",
                        height: "60px", 
                      },
                      padding: "12px 0",
                      "&:hover": { backgroundColor: activeOrder === order._id ? "white" : buttonColor, boxShadow: "none" },
                    }}
                    onClick={() => this.handleToggleOrder(order._id)}
                  >
                      {/* Conditional rendering of avatar or icon based on delivery mode */}
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        {order.deliveryMode === "STORE_PICKUP" ? (
                        <StorefrontIcon 
                          sx={{ 
                          width: 24, 
                          height: 24, 
                          marginLeft: 2,
                          "@media (max-width: 600px)": {
                              margin: "0 4px", 
                              display: "block"
                            } 
                        }} />
                      ) : order.deliveryMode === "HOME_DELIVERY" ? (
                        <HomeIcon 
                          sx={{ 
                          width: 24, 
                          height: 24, 
                          marginLeft: 2,
                          "@media (max-width: 600px)": {
                            margin: "0 4px", 
                            display: "block",
                          } 
                        }} />
                      ) : (
                        <Avatar src={order.platformLogo} sx={{ width: 24, height: 24, marginRight: 1 }} />
                      )}
                      </div>
                    <Typography fontWeight="bold" 
                      sx={{
                        whiteSpace: "normal", 
                        //wordBreak: "break-word",
                        //padding: "0 25px",
                        fontSize: "13.5px",
                        marginRight: 2,
                        "@media (max-width: 600px)": {
                          fontSize: "13px",
                          padding: "0 10px",
                        }
                      }}
                    >
                    #{`${order.id} | ${dayjs(order.createdAt).format("DD-MM-YYYY hh:mm A")}`}
                    </Typography>
                    {/*order.isDelivered&& (
                      <CheckCircleIcon
                        sx={{
                          position: "absolute",
                          right: 8, 
                          top: 15,
                          "@media (max-width: 600px)": {
                            top: 19,
                            fontSize: "16px",  
                          },  
                          color: isExpanded ? "black" : "white", 
                          fontSize: "18px", 
                        }}
                      />
                    )}
                    {order.isCancelled && (
                      <CancelIcon
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 15,
                        "@media (max-width: 600px)": {
                            top: 19,
                            fontSize: "16px",  
                          },
                        color: isExpanded ? "black" : "white",
                        fontSize: "18px",
                      }}
                    />
                    )}
                    
                    {/* Status icons in right corner */}
                    {/*order.paymentId?.status === "pending" && !order.isOrderAccepted && !order.isCancelled && (
                      <AccessTimeIcon
                        sx={{
                          position: "absolute",
                          right: 8,
                          top: 15,
                          "@media (max-width: 600px)": {
                            top: 18,
                            fontSize: "16px",  
                          },
                          color: isExpanded ? "black" : "white",
                          fontSize: "18px",
                        }}
                      />
                    )}
                    {order.isOrderAccepted && !order.isDelivered && !order.isCancelled && !order.isDispatched && order.paymentId?.status === "pending"  && (
                    <Box 
                      sx={{ 
                      position: "absolute", 
                      right: 8, 
                      top: 13,
                      "@media (max-width: 600px)": {
                            top: 17, 
                            fontSize: "10px", 
                          }, 
                      }}>
                      <ArticleIcon
                        sx={{
                          color: isExpanded ? "black" : "white",
                          fontSize: "18px",
                          "@media (max-width: 600px)": {
                            fontSize: "16px", 
                          },
                        }}
                      />
                      <CheckIcon
                        sx={{
                          position: "absolute",
                          right: "-1px",
                          bottom: "-1px",
                          color: isExpanded ? "grey" : "black",
                          fontSize: "17px",
                          "@media (max-width: 600px)": {
                            fontSize: "14px", 
                          },
                          fontWeight: "bold",
                        }}
                      />
                    </Box>
                  )}
                  {order.paymentId?.status === "done" && !order.isDelivered && !order.isDispatched && (
                      <MonetizationOnIcon
                        sx={{
                          position: "absolute",
                          right: 8,
                          top: 15,
                          "@media (max-width: 600px)": {
                            top: 19,
                            fontSize: "15px", 
                          },
                          color: isExpanded ? "black" : "white",
                          fontSize: "18px",
                        }}
                      />
                    )}
                    {order.deliveryMode === "HOME_DELIVERY" && order.isDispatched === true && !order.isDelivered && order.paymentId?.status === "done" && (
                    <LocalShippingIcon
                      sx={{
                        position: "absolute",
                        right: 8,
                        top: 15,
                        "@media (max-width: 600px)": {
                            top: 19,
                            fontSize: "16px",
                          },
                        color: isExpanded ? "black" : "white",
                        fontSize: "18px",
                      }}
                    />
                  )*/}

                  </Button>

                  <Collapse in={isExpanded}>
                    <CardContent sx={{ borderRadius: "12px", padding: "10px",maxHeight: "480px", backgroundColor: "white" }}>
                    <CardContent sx={{ borderRadius: "12px", padding: "10px", backgroundColor: "white", maxHeight: "300px", overflowY: "auto" }}>

                    <div style={{display: "flex-end",borderBottom: "1px solid #ddd", paddingBottom: "5px",marginTop: 'auto'}}>
                    <div style={{ display: "flex", justifyContent: "flex-start", fontWeight: "bold", fontSize: "12px",  }}>
                      <span>Name: {order.userDetails?.name || "Guest User"}, </span>
                    </div> 
                    <div style={{ display: "flex", justifyContent: "flex-start", fontWeight: "bold", fontSize: "12px",  }}>                       
                      <span>Mobile: {order.userDetails?.mobile || ""}</span>
                    </div>
                    <div style={{display: "flex", justifyContent: "flex-start",fontWeight: "bold", fontSize: "12px"}}>
                      <span>Address: {order.addressId?.street1 || "No Address"} {order.addressId?.pincode || ""}</span>
                    </div>
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-start", fontWeight: "bold", fontSize: "12px",  }}>                       
                      <span>Status: {order.paymentDetails?.status === "done" ? 'paid' : 'unpaid'}</span>
                    </div>
                    <hr style={{ margin: "8px 0", borderColor: "#ddd", borderTop: "1px solid grey" }} />
                      {/* Display order items */}
                      <div style={{ width: "100%", marginBottom: "10px" }}>
                        <div style={{ 
                           display: "flex", 
                           justifyContent: "space-between", 
                           fontWeight: "bold", fontSize: "12px", 
                           borderBottom: "1px solid #ddd", 
                           paddingBottom: "5px",
                           "@media (max-width: 600px)": {
                            fontSize: "10px",
                            paddingBottom: "10px", 
                          } 
                           }}>
                          <span style={{ width: "30%", textAlign: "left" }}>Product</span>
                          <span style={{ width: "10%", textAlign: "left" }}>Quantity</span>
                          <span style={{ width: "18%", textAlign: "left" }}>Price</span>
                        </div>
                        {Object.values(order.cartrequest || []).map((item, index) => (
                          <div key={index} style={{ display: "flex", justifyContent: "space-between", padding: "0.5px 0", fontSize: "12px" }}>
                            <span style={{ width: "30%", textAlign: "left" }}>{item?.name || "Unknown Product"}</span>
                            <span style={{ width: "10%" }}>{item.count}</span>
                            <span style={{ width: "18%", textAlign: "left" }}>
                              {currencySymbol}{" "}{((order.orderFrom === "instore" ? item.storePrice : (item.priceDiscount > 0 ? item.priceDiscounted : item.price)) * item.count).toFixed(2)}
                            </span>
                          </div>
                        ))}
                        {/* Handling Free Product Display */}
                        {order?.freeProducts && order.freeProducts.map((freeProduct, index) => (
                          <div key={index} style={{ display: "flex", justifyContent: "space-between", padding: "0.5px 0", fontSize: "12px", fontWeight: "bold" }}>
                            <span style={{ width: "30%", textAlign: "left" }}>
                              {freeProduct.name || "Free Product"}
                            </span>
                            <span style={{ width: "10%" }}>
                            </span>
                            <span style={{ width: "18%", textAlign: "left", color: "red" }}>
                              Free
                            </span>
                          </div>
                        ))}
                      </div>
                      <hr style={{ margin: "8px 0", borderColor: "#ddd", borderTop: "1px solid grey" }} />
                      <Typography fontSize={13} sx={{ display: "flex", justifyContent: "space-between" }}>
                        <span>Subtotal:</span>
                        <span>{currencySymbol} {order.amountTotal || 0}</span>
                      </Typography>
                      <Typography fontSize={13} sx={{ display: "flex", justifyContent: "space-between" }}>
                        <span>Delivery:</span>
                        <span>
                          {currencySymbol} 
                          {(!isNaN(order.deliveryCharge))  
                            ? Number(order.deliveryCharge).toFixed(2) 
                              : '0.00'}
                        </span>
                      </Typography>
                      <Typography fontSize={13} sx={{ display: "flex", justifyContent: "space-between" }}>
                        <span>Tax:</span>
                        <span>{currencySymbol} {(parseFloat(order.taxAmount) || 0).toFixed(2)}</span>
                      </Typography>
                      <Typography fontSize={13} sx={{ display: "flex", justifyContent: "space-between" }}>
                        <span>Discount:</span>
                        <span>{currencySymbol} {(parseFloat(order.discount) || 0).toFixed(2)}</span>
                      </Typography>
                      <Typography fontSize={13} sx={{ display: "flex", justifyContent: "space-between" }}>
                        <span>Other Charges:</span>
                        <span>{currencySymbol} {(parseFloat(order.otherCharges) || 0).toFixed(2)}</span>
                      </Typography>
                      <hr style={{ margin: "8px 0", borderColor: "#ddd", borderTop: "1px solid grey" }} />
                      {order.redeemedCouponDetails && (
                        <Typography 
                          fontSize={13} 
                          sx={{ display: "flex", justifyContent: "space-between", color: "green", cursor: 'pointer' }} 
                          onClick={(event) => this.openCouponPopover(event, order.redeemedCouponDetails)}
                        >
                          <span>Coupon Applied:</span>
                          <span>{order.redeemedCouponDetails.voucherCode || null}</span>
                        </Typography>
                      )}
                      <Typography fontSize={14} fontWeight="bold" sx={{ display: "flex", justifyContent: "space-between", marginTop: "8px" }}>
                        <span>Total: </span>
                        <span>{currencySymbol} {order.grandTotal || 0}</span>
                      </Typography>
                      </CardContent>
                      {order.uberDelivery && order.uberDelivery?.deliveryStatus && (
                        <div style={{ marginTop: "10px", fontSize: "13px", }}>
                          Uber Delivery Status: {order.uberDelivery.deliveryStatus}
                        </div>
                      )}
                      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '4px 0', marginTop: 'auto' }}>
  
                        <div style={{ display: 'flex', gap: '4px' }}>
                          {/* Delete Button */}
                          <Tooltip title={order.paymentDetails.status === "done" ? "Cannot delete at this stage" : "Delete"} arrow>
                            <IconButton color="error" onClick={order.paymentDetails.status !== "done" ? this.onDelete(order._id) : null} disabled={!permissions.canDelete}>
                              <DeleteIcon />
                            </IconButton>
                          </Tooltip>
                          
                          {/* Cancel Button */}
                          <Tooltip title={isCancelDisabled ? "Cannot cancel at this stage" : "Cancel"} arrow>
                            <IconButton sx={{ color: "grey" }} onClick={this.onCancel(order._id)} disabled={!permissions.canDelete}>
                              <CancelIcon />
                            </IconButton>
                          </Tooltip>

                          {/* Preferences Button */}
                          {order.preferences && (
                            <Tooltip title="View Customer Preferences" arrow>
                              <IconButton 
                                color="primary"
                                onClick={() => this.handleOpenPreferenceModal(order.preferences)}
                              >
                                <ArticleIcon />
                              </IconButton>
                            </Tooltip>
                          )}
                        </div>

                        <div style={{ display: 'flex', gap: '4px' }}>
                        {order.uberDelivery && order.uberDelivery?.trackingUrl && (
                          <Tooltip title="Delivery Status URL" arrow>
                            <IconButton
                              color="primary"
                              onClick={() => {
                                if (permissions.canEdit) {
                                  window.open(order.uberDelivery.trackingUrl, "_blank");
                                }
                              }}
                              disabled={!permissions.canEdit}
                            >
                              <DirectionsCar />
                            </IconButton>
                          </Tooltip>
                        )}
                          {/* Print Button */}
                        {permissions.canEdit ? (
                          <Tooltip title="Print" arrow>
                            <Link to={routes.orderPrint.path(order._id)}>
                              <IconButton color="primary">
                                <PrintIcon />
                              </IconButton>
                            </Link>
                          </Tooltip>
                          ) : (
                            <IconButton color="primary" disabled>
                              <PrintIcon />
                            </IconButton>
                        )}
                          
                          {/* Barcode (Scanner) Button */}
                        <Tooltip title="View QR payment" arrow>
                          <span>
                            <IconButton 
                              sx={{ color: "black", fontWeight: "bold", backgroundColor: "transparent", "&:hover": { color: "#000" } }} 
                              onClick={this.handleOpenBarcodeModal}
                              disabled
                            >
                              <QrCodeIcon />
                            </IconButton>
                          </span>
                        </Tooltip>
                        </div>

                      </div>
                      
                      {/* Accept/Paid/Dispatch/Deliver Button */}
                       <Tooltip
                        title={
                          this.state.loadingStatus[order._id] === "In Progress" ||
                          (order.paymentDetails?.status === "done" &&
                           order.deliveryMode === "HOME_DELIVERY" &&
                           order.isDispatched &&
                           order?.isUberDelivery &&
                           order.uberDelivery?.deliveryStatus !== "delivered")
                           ? "Click to get Uber delivery status"
                           : ""
                        }
                        disableHoverListener={
                        !( this.state.loadingStatus[order._id] === "In Progress" ||
                          (order.paymentDetails?.status === "done" &&
                           order.deliveryMode === "HOME_DELIVERY" &&
                           order.isDispatched &&
                           order?.isUberDelivery &&
                           order.uberDelivery?.deliveryStatus !== "delivered")
                          )
                        }
                      >
                      <Button
                        sx={{
                          backgroundColor: order.isCancelled
                            ? "#ffb3b3" 
                            : !order.isOrderAccepted
                            ? "#99c2ff" 
                            : order.paymentDetails?.status === "pending" && !order.isDispatched && !order.isDelivered
                            ? "#99e6ff" 
                            : order.paymentDetails?.status === "done" && order.deliveryMode === "HOME_DELIVERY" && order.isDispatched === false
                            ? "#99e6ff" 
                            : order.isDelivered === false && !order.isDispatched === false
                            ? "#99e699" 
                            : "#99e699",
                          color: "black", 
                          marginTop: "2px",
                          padding: "4px",
                          borderRadius: "20px",
                          fontSize: "14px",
                          fontWeight: "bold",
                          width: "50%",
                          border: `2px solid ${
                            order.isCancelled
                              ? "#ff9999" 
                              : !order.isOrderAccepted
                              ? "#80b3ff" 
                              : order.paymentDetails?.status === "pending" && !order.isDispatched && !order.isDelivered
                              ? "#80dfff" 
                              : order.paymentDetails?.status === "done" && order.deliveryMode === "HOME_DELIVERY" && order.isDispatched === false
                              ? "#80dfff" 
                              : order.isDelivered === false && !order.isDispatched === false
                              ? "#80cc80" 
                              : "#80cc80"
                          }`, 
                          "&:hover": {
                            backgroundColor: order.isCancelled
                              ? "#ff9999" 
                              : !order.isOrderAccepted
                              ? "#80b3ff" 
                              : order.paymentDetails?.status === "pending" && !order.isDispatched && !order.isDelivered
                              ? "#80dfff" 
                              : order.paymentDetails?.status === "done" && order.deliveryMode === "HOME_DELIVERY" && order.isDispatched === false
                              ? "#80dfff" 
                              : order.isDelivered === false && !order.isDispatched === false
                              ? "#80cc80" 
                              : "#80cc80",
                            border: `2px solid ${
                              order.isCancelled
                                ? "#ff6666" 
                                : !order.isOrderAccepted
                                ? "#6699ff" 
                                : order.paymentDetails?.status === "pending" && !order.isDispatched && !order.isDelivered
                                ? "#66c2ff" 
                                : order.paymentDetails?.status === "done" && order.deliveryMode === "HOME_DELIVERY" && order.isDispatched === false
                                ? "#66c2ff" 
                                : order.isDelivered === false && !order.isDispatched === false
                                ? "#66b366" 
                                : "#66b366"
                            }`, 
                          },
                        }}
                        onClick={() => {
                          if (!order.isCancelled) {
                            if (!order.isOrderAccepted) {
                              this.handleOrderStatusChange(order._id, order.isOrderAccepted);
                            } else if (order.paymentDetails?.status !== "done") {
                              this.handlePaidStatusChange(order._id, order.paymentDetails?.status);
                            } else if (order.paymentDetails?.status === "done" && order.deliveryMode === "STORE_PICKUP") {
                              this.handleDeliverStatusChange(order._id);
                            } else if (order.paymentDetails?.status === "done" && order.deliveryMode === "HOME_DELIVERY" && !order.isDispatched) {
                              this.handleDispatchStatusChange(order._id);
                            } else if (order.isDispatched && !order.isDelivered) {
                              if (order?.isUberDelivery && order.uberDelivery?.deliveryStatus !== "delivered") {
                                this.handleOrderClick(order);
                              } else {
                                this.handleDeliverStatusChange(order._id);
                              }
                            }
                          }
                        }}
                        disabled={order.isCancelled || order.isDelivered || (order.isDispatched && order.deliveryMode === "HOME_DELIVERY" && order.isDelivered) || !this.state.permissions.canEdit}
                      >
                        {this.state.loadingStatus[order._id] ||
                          (order.isCancelled
                            ? "Cancelled"
                            : order.isDelivered
                            ? "Delivered"
                            : !order.isOrderAccepted
                            ? "Accept"
                            : order.paymentDetails?.status === "done"
                            ? order.deliveryMode === "STORE_PICKUP"
                              ? "Deliver"
                              : order.isDispatched
                              ? order?.isUberDelivery && order.uberDelivery?.deliveryStatus !== "delivered"
                                ? "In progress"
                                : "Deliver"
                              : "Dispatch"
                            : "Paid")}
                      </Button>
                      </Tooltip>
                    </CardContent>
                  </Collapse>
                </Card>
                </Box>
              );
          })}
          </div>
        )}
        <Pagination
          count={Math.ceil(this.state.count / this.state.itemsPerPage)}
          page={this.state.page}
          onChange={this.handlePageChange}
          color="primary"
          sx={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}
        />
        </>
        )}
        </div>
        <Backdrop
        open={Boolean(anchorEl)}
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.drawer + 1,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',  
        }}
      />
        {this.state.anchorEl && this.state.selectedCoupon && (
          <Popover
          open={Boolean(this.state.anchorEl)}
          anchorEl={this.state.anchorEl}
          onClose={this.closeCouponPopover}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'center',
          }}
          sx={{ padding: "2px" }}
        >
          <Card sx={{ 
              padding: "16px", 
              minWidth: "250px", 
              maxWidth: "300px", 
              borderRadius: "10px", 
              boxShadow: 3, 
              backgroundColor: "#fff" 
            }}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              Coupon Details
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
              {[
                { label: "Reward Name", value: this.state.selectedCoupon.rewardName },
                { label: "Voucher Code", value: this.state.selectedCoupon.voucherCode },
                { label: "Discount", value: `${this.state.selectedCoupon.onlineDeals?.discountPercentage}%` },
                { label: "MaxDiscount Amount", value: this.state.selectedCoupon.onlineDeals?.maxDiscountAmount },
                { label: "MinOrder Amount", value: this.state.selectedCoupon.onlineDeals?.minOrderAmount ? `${currencySymbol}${this.state.selectedCoupon.onlineDeals.minOrderAmount}` : "N/A" },
                { label: "Start Date", value: dayjs(this.state.selectedCoupon.startDate).format("MMM D, YYYY") },
                { label: "Expiry Date", value: dayjs(this.state.selectedCoupon.expiryDate).format("MMM D, YYYY") },
                { label: "Start Time", value: dayjs(this.state.selectedCoupon.startTime, "HH:mm").format("hh:mm A") },
                { label: "End Time", value: dayjs(this.state.selectedCoupon.endTime, "HH:mm").format("hh:mm A") },
              ].map((item, index) => (
                <Box key={index} sx={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "12px" }}>
                  <Typography variant="body2" sx={{ fontWeight: index < 1 ? "bold" : "normal", whiteSpace: "nowrap" }}>
                    {item.label}:
                  </Typography>
                  <Typography variant="body2" sx={{ textAlign: "right", fontWeight: index < 1 ? "bold" : "normal", wordBreak: "break-word" }}>
                    {item.value || "N/A"}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Card>
        </Popover>
        )}

        {/* Modal for Barcode */}
        <Modal
          open={barcodeModalOpen}
          onClose={this.handleCloseBarcodeModal}
          aria-labelledby="modal-barcode"
          aria-describedby="modal-barcode-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              backgroundColor: "white",
              padding: 2,
              borderRadius: 2,
              boxShadow: 3,
              minWidth: "300px",  
            }}
          >
            {/* Placeholder for large barcode */}
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "200px",
                width: "100%",
                backgroundColor: "#f0f0f0",
                border: "1px solid #ddd",
                textAlign: "center",
              }}
            >
              <QrCodeIcon style={{ width: '100%', height: '100%', color: "#333" }} />
              {/* Replace this with an actual barcode once implemented */}
            </div>
          </Box>
        </Modal>

        <Modal
          open={this.state.showDeliveryChoiceModal}
          onClose={(event, reason) => {
            if (reason !== 'backdropClick' && reason !== 'escapeKeyDown') {
             this.state.onDeliveryChoice('SELF');
            }
          }}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          disableEscapeKeyDown
        >
        <Box
          sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: 450,
          bgcolor: 'background.paper',
          borderRadius: 2,
          boxShadow: 24,
          p: 8,
          textAlign: 'center'
        }}
        >
          <Typography id="modal-title" variant="h6" component="h2" gutterBottom sx={{ marginBottom: '25px'}}>
             Select Delivery Mode
          </Typography>
          <Typography id="modal-description" sx={{ mb: 3 }}>
               Both <strong>Self</strong> and <strong>Uber</strong> delivery options are configured. Please select your preferred method.
          </Typography>
          
          <Box display="flex" justifyContent="space-around">
           <Button
              variant="contained"
              onClick={() => this.state.onDeliveryChoice('SELF')}
            >
             Self Delivery
            </Button>
            <Button
              variant="contained"
              onClick={() => this.state.onDeliveryChoice('UBER')}
            >
             Uber Delivery
            </Button>
          </Box>
         </Box>
        </Modal>

        {/* Modal for Order Preferences */}
        <Modal
          open={this.state.preferenceModalOpen}
          onClose={this.handleClosePreferenceModal}
          aria-labelledby="modal-preference-title"
          aria-describedby="modal-preference-description"
        >
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              bgcolor: "white",
              padding: 0,
              borderRadius: "16px",
              boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
              minWidth: "350px",
              maxWidth: "500px",
              width: "90%",
              overflow: "hidden"
            }}
          >
            <Box sx={{ 
              backgroundColor: "#f4f5f7", 
              padding: "16px 24px", 
              borderBottom: "1px solid #e0e6ed",
              display: "flex", 
              justifyContent: "space-between", 
              alignItems: "center" 
            }}>
              <Typography id="modal-preference-title" variant="h6" sx={{ fontWeight: 'bold', display: 'flex', alignItems: 'center', gap: 1, color: '#32325d', fontSize: '18px' }}>
                Customer Preferences
              </Typography>
              <IconButton
                aria-label="close"
                onClick={this.handleClosePreferenceModal}
                size="small"
                sx={{
                  color: "#8898aa",
                  "&:hover": { color: "#32325d", backgroundColor: "#e9ecef" }
                }}
              >
                <CloseIcon fontSize="small" />
              </IconButton>
            </Box>
            
            <Box sx={{ padding: "24px" }}>
                <Typography variant="body1" sx={{ color: '#525f7f', whiteSpace: 'pre-wrap', lineHeight: 1.6, padding: '10px' }}>
                  {this.state.selectedPreferences }
                </Typography>
            </Box>
          </Box>
        </Modal>


      </SectionPaper>

      {/* Quick Tips Section */}
      <Box sx={{ p: 2, pt: 2 }}>
        <Box 
          sx={{ 
            backgroundColor: '#F8F9FE', 
            borderRadius: '8px', 
            border: '1px solid #E9ECEF',
            p: 3
          }}
        >
          <Box display="flex" alignItems="center" justifyContent="space-between" mb={2} sx={{ color: '#5E72E4' }}>
            <Box display="flex" alignItems="center">
              <LightbulbOutlinedIcon sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="subtitle2" sx={{ fontWeight: 700, letterSpacing: '0.5px', textTransform: 'uppercase' }}>
                LIVE ORDERS QUICK TIPS
              </Typography>
            </Box>
            <Box display="flex" gap={1}>
              {settingsData?.webAppUrl && (
                <Button 
                  href={`${settingsData.webAppUrl}/gotoappstore`}
                  target="_blank" 
                  size="small" 
                  startIcon={<SmartphoneIcon />}
                  sx={{ 
                    color: '#5E72E4', 
                    fontWeight: 600, 
                    textTransform: 'none',
                    '&:hover': { backgroundColor: 'rgba(94, 114, 228, 0.08)' }
                  }}
                >
                  Download App
                </Button>
              )}
            </Box>
          </Box>

          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Box display="flex" alignItems="flex-start">
                <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
                <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                  <span style={{ fontWeight: 600, color: '#32325D' }}>Order Workflow:</span> Track orders from Accept to Paid, Dispatch, and finally Deliver. The status button updates dynamically based on the current stage.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box display="flex" alignItems="flex-start">
                <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
                <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                  <span style={{ fontWeight: 600, color: '#32325D' }}>Mobile App:</span> Use the admin mobile app for instant notifications on new orders and to track or manage live orders on the go.
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={12} md={4}>
              <Box display="flex" alignItems="flex-start">
                <ChevronRightIcon sx={{ color: '#5E72E4', fontSize: 20, mt: '2px', mr: 1, flexShrink: 0 }} />
                <Typography variant="body2" sx={{ color: '#525F7F', lineHeight: 1.6 }}>
                  <span style={{ fontWeight: 600, color: '#32325D' }}>Delivery Integration:</span> If enabled, you can manage Uber or Self-delivery directly from each order card once the order is dispatched.
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </Box>
      </>
    );
  }
}

LiveOrder.propTypes = {
  list: PropTypes.func.isRequired,
  messageShow: PropTypes.func.isRequired,
  orderacceptedToggle: PropTypes.func.isRequired,
  paidToggle: PropTypes.func.isRequired,
  dispatchToggle: PropTypes.func.isRequired,
  deliverToggle: PropTypes.func.isRequired,
  cancel: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  getLiveOrders: PropTypes.func.isRequired,
  getPendingOrders: PropTypes.func.isRequired
};

export default connect(null, { getLiveOrders, getPendingOrders, list, messageShow, orderacceptedToggle, paidToggle, dispatchToggle, deliverToggle, cancel, remove })(LiveOrder);
